<template>
  <footer class="py-4 bg-light mt-auto" >
    <div class="container-fluid">
      <div class="d-flex align-items-center justify-content-between small">
        <div class="text-muted">
          <a id="copy-right" href="https://krbsgroup.com/krbswebsite/" target="_blank"><span>Copyright &copy; https://krbsgroup.com 2022</span></a>
        </div>
        <div>
          <label>
            <span>Build Version</span>
          </label>
          &middot;
          <label>
            <span>{{ buildVersion }}</span>
          </label>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import packageJson from '../../../package.json'; // Adjust the path if needed
export default {
  name: 'BaseAppFooter',

  /** mixins **/
  mixins: [],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {
      buildVersion: packageJson.version
    };
  },

  /** methods**/
  methods: {},

  /**  computed  **/
  computed: {},

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },

};
</script>

<style scoped>

.pt-4, .py-4 {
  padding-top: 1.0rem !important;
}
</style>
